/* KrakenTheMeta dashboard — improve a deck with AI (the builder's AI tab, "Improve this deck").
 * Keeps the deck and its commander. The Kraken proposes swaps — one card out, one card in, each with
 * a reason — and only the swaps the player keeps are written. Server: the upgradeDeck callable
 * (functions/deck-upgrade.js), which checks every pick against Scryfall, the format, the colors,
 * the bracket and the land count. Added 2026-10-03: the most common written cancellation reason
 * was "it only builds new decks, it can't upgrade mine".
 */
(function () {
  "use strict";

  var KD = window.KD, S = KD.state, D = KD.data, esc = KD.esc;
  var B = (KD.builder = KD.builder || {});

  var GOALS = [
    { id: "weak", label: "Upgrade the weakest cards", goal: "Upgrade the weakest cards and keep the game plan." },
    { id: "removal", label: "More removal", goal: "More removal and interaction." },
    { id: "draw", label: "More card draw", goal: "More card draw." },
    { id: "ramp", label: "More ramp", goal: "More ramp." },
    { id: "mana", label: "Fix the mana", goal: "Fix the mana base." },
    { id: "curve", label: "Lower the curve", goal: "Lower the mana curve." },
    { id: "cheaper", label: "Make it cheaper", goal: "Make it cheaper." },
    { id: "stronger", label: "Make it stronger", goal: "Make it stronger." }
  ];
  var STAGES = [
    ["layers", "Reading your deck", "Roles, curve, colors and bracket: the same read as the Deck Analyzer."],
    ["sparkle", "Finding better cards", "Swaps that serve your commander's plan and the goal you picked."],
    ["shield", "Checking every swap", "Real cards, legal, in your colors and budget, or they're dropped."]
  ];

  function lc(s) { return String(s || "").toLowerCase(); }
  function thumb(url, alt) {
    var u = KD.safeUrl(D.artUrl(url || ""));
    return u ? '<img src="' + esc(u) + '" alt="' + esc(alt || "") + '" loading="lazy" decoding="async">' : '<span class="swap__noimg">' + KD.icon("mtgcard") + "</span>";
  }
  function money(p) { return p == null || isNaN(p) ? "" : "$" + Number(p).toFixed(2); }

  // ---------------------------------------------------------------- the form
  // host: the AI panel body. o: { deck, cards, preset: { goal, goals:[ids] } }. Returns nothing;
  // runs the upgrade itself and opens the review.
  KD.improve = {
    paint: function (host, o) {
      var deck = o.deck, isCmd = D.isCommanderFormat(deck.format), brackets = isCmd && !D.isBrawlFormat(deck.format);
      var preset = o.preset || {};
      var on = new Set(preset.goals && preset.goals.length ? preset.goals : (preset.goal ? [] : ["weak"]));
      var big = D.targetSize(deck.format) >= 100;
      var sizes = big ? [5, 10, 15] : [3, 6, 10];
      var size = preset.changes || sizes[1];
      host.innerHTML = '<div class="improve">' +
        '<p class="improve__lede">Keeps your deck' + (isCmd ? " and its commander" : "") + '. The Kraken suggests swaps, one card out and one card in, each with a reason, and you keep the ones you like.</p>' +
        '<div class="field"><span class="label">What should change?</span>' +
          '<div class="goalchips" role="group" aria-label="Goals">' + GOALS.map(function (g) {
            var sel = on.has(g.id);
            return '<button type="button" class="chip' + (sel ? " is-on" : "") + '" data-goal="' + g.id + '" aria-pressed="' + sel + '">' + esc(g.label) + "</button>";
          }).join("") + "</div></div>" +
        '<label class="field"><span class="label">Anything specific? (optional)</span>' +
          '<textarea class="textarea improve__text" data-imp-text maxlength="400" placeholder="e.g. more ways to protect my commander, no infinite combos">' + esc(preset.goal || "") + "</textarea></label>" +
        '<div class="aiform__row">' +
          '<div class="field"><span class="label">About how many swaps</span><div class="seg seg--block" role="radiogroup" aria-label="How many swaps">' + sizes.map(function (n) {
            return '<button type="button" role="radio" data-size="' + n + '" aria-checked="' + (n === size) + '" aria-selected="' + (n === size) + '">' + n + "</button>";
          }).join("") + "</div></div>" +
          (brackets ? '<label class="field"><span class="label">Power</span><select class="select" data-imp-bracket>' +
            '<option value="">Keep its bracket</option><option value="2">Bracket 2 · Core</option><option value="3">Bracket 3 · Upgraded</option><option value="4">Bracket 4 · Optimized</option><option value="5">Bracket 5 · cEDH</option></select></label>' : "") +
        "</div>" +
        "<details data-imp-adv><summary>More options" + KD.icon("down") + '</summary><div class="aiform__adv">' +
          '<label class="field"><span class="label">Most you’ll pay per new card ($, optional)</span><input class="input" type="number" min="0.25" step="0.25" inputmode="decimal" data-imp-budget placeholder="No limit"></label>' +
          '<label class="check" data-imp-coll-wrap><input type="checkbox" data-imp-coll><span>Only suggest cards I own</span></label>' +
          '<label class="check" data-imp-noreuse-wrap hidden><input type="checkbox" data-imp-noreuse><span>Don’t take cards my other decks use</span></label>' +
          '<label class="field"><span class="label">Never add (optional)</span><textarea class="textarea" data-imp-exclude style="min-height:64px" placeholder="One per line"></textarea></label>' +
        "</div></details>" +
        '<button class="btn btn--lure btn--block" type="button" data-imp-go>' + KD.icon("sparkle") + "<span>Find upgrades</span></button>" +
        '<p class="gensline" data-gensline style="justify-content:center"></p>' +
        "</div>";
      var $ = function (s) { return KD.$(s, host); };
      KD.paintGensLine($("[data-gensline]"));
      KD.$$("[data-goal]", host).forEach(function (b) {
        b.addEventListener("click", function () {
          var id = b.dataset.goal;
          if (on.has(id)) on.delete(id);
          else {
            if (id === "weak") on.clear(); else on.delete("weak");
            on.add(id);
            if (on.size > 3) on.delete(Array.from(on)[0]);
          }
          KD.$$("[data-goal]", host).forEach(function (x) { var s2 = on.has(x.dataset.goal); x.classList.toggle("is-on", s2); x.setAttribute("aria-pressed", String(s2)); });
        });
      });
      KD.$$("[data-size]", host).forEach(function (b) {
        b.addEventListener("click", function () {
          size = parseInt(b.dataset.size, 10);
          KD.$$("[data-size]", host).forEach(function (x) { var s2 = x === b; x.setAttribute("aria-checked", String(s2)); x.setAttribute("aria-selected", String(s2)); });
        });
      });
      var coll = $("[data-imp-coll]");
      coll.addEventListener("change", function () { $("[data-imp-noreuse-wrap]").hidden = !coll.checked; });
      D.loadCollection().then(function () {
        var empty = S.collectionLoaded && !(S.collection || []).length;
        coll.disabled = empty;
        $("[data-imp-coll-wrap]").classList.toggle("is-disabled", empty);
      }).catch(function () {});
      if (preset.goal || preset.goals) setTimeout(function () { try { $("[data-imp-go]").focus({ preventScroll: true }); } catch (e) { /* ignore */ } }, 60);
      $("[data-imp-go]").addEventListener("click", function () {
        var goals = GOALS.filter(function (g) { return on.has(g.id); }).map(function (g) { return g.goal; });
        var extra = $("[data-imp-text]").value.trim();
        var budget = Number($("[data-imp-budget]").value);
        var exclude = ($("[data-imp-exclude]").value || "").split(/\n/).map(function (s2) { return s2.trim(); }).filter(Boolean).slice(0, 40);
        KD.improve.run({
          goal: (goals.join(" ") + (extra ? " " + extra : "")).trim() || GOALS[0].goal,
          changes: size,
          bracket: brackets && $("[data-imp-bracket]").value ? parseInt($("[data-imp-bracket]").value, 10) : null,
          budgetPerCard: budget > 0 ? budget : null,
          useCollection: coll.checked && !coll.disabled,
          noReuse: coll.checked && $("[data-imp-noreuse]").checked,
          exclude: exclude,
          avoid: []
        });
      });
    },

    // ---------------------------------------------------------------- the run
    run: async function (o) {
      var host = B.host;
      if (!host || !host.deck()) return;
      var deck = host.deck(), cards = host.cards();
      if (!cards.length) { KD.toast("Add or import some cards first, then the Kraken can improve them.", "info"); return; }
      var g = D.gens();
      if (!g.unlimited && g.left <= 0) { KD.upsell(); return; }
      if (o.useCollection && o.noReuse) {
        try { var res = await D.computeReserved(deck.id); if (Object.keys(res.map).length) o.reserved = res.map; }
        catch (e) { KD.toast("Couldn't check your other decks, so suggestions may use their cards.", "info"); }
      }
      KD.ga("upgrade_start", { format: deck.format, changes: o.changes });
      KD.brew.start({
        format: D.formatLabel(deck.format), size: D.deckStats(cards).total, stages: STAGES, at: [8, 40],
        title: "<h2>Improving <em>your deck.</em></h2>", note: "Usually under a minute. Your deck isn't touched until you choose what to keep.",
        longAfter: 90, longNote: "checking a long list of swaps", promo: false
      });
      var data;
      try {
        data = await D.upgrade(deck, cards, o);
      } catch (e) {
        KD.brew.stop();
        console.error("upgrade", e);
        if (e.code === "functions/resource-exhausted") KD.upsell(e.message);
        else if ((e.code === "functions/failed-precondition" || e.code === "functions/invalid-argument") && e.message) KD.toast(e.message, "err");
        else KD.toast("The upgrade didn't finish. Please try again. No AI build was used.", "err");
        return;
      }
      KD.brew.stop();
      try { await D.loadProfile(); KD.paintGens(); } catch (e) { /* the meter refreshes next load */ }
      KD.ga("upgrade_done", { format: deck.format, swaps: (data.swaps || []).length });
      if (B.host !== host || host.deck() !== deck) return; // the player left the deck meanwhile
      KD.improve.review(data, o);
    },

    // ---------------------------------------------------------------- the review
    review: function (data, o) {
      var host = B.host, deck = host.deck();
      var swaps = data.swaps || [], extraAdds = data.extraAdds || [], extraCuts = data.extraCuts || [];
      if (!swaps.length && !extraAdds.length && !extraCuts.length) {
        KD.sheet({ title: "Nothing worth changing", body: '<p class="hint">' + esc(data.summary || "This deck already does what you asked.") + "</p>" + notesHtml(data),
          foot: '<button class="btn btn--lure" type="button" data-close>Done</button>' });
        return;
      }
      // a cut card that came back without art borrows the image the deck already has
      var deckImg = {};
      host.cards().forEach(function (c) { if (c.name && c.imageUrl) deckImg[lc(c.name)] = c.imageUrl; });
      swaps.forEach(function (x) { if (!x.cut.imageUrl) x.cut.imageUrl = deckImg[lc(x.cut.name)] || ""; });
      var keep = swaps.map(function () { return true; });
      var b = data.before || {}, a = data.after || {};
      var stat = function (label, k, fmt) {
        if (b[k] == null && a[k] == null) return "";
        var from = fmt ? fmt(b[k]) : b[k], to = fmt ? fmt(a[k]) : a[k];
        var changed = String(from) !== String(to);
        return '<div class="review__stat' + (changed ? " is-changed" : "") + '"><span>' + label + "</span><b>" + esc(String(from)) + (changed ? ' <i aria-hidden="true">→</i> ' + esc(String(to)) : "") + "</b></div>";
      };
      var stats = stat("Lands", "lands") + stat("Ramp", "ramp") + stat("Draw", "draw") + stat("Removal", "removal") + stat("Wipes", "wipe") +
        (b.bracket ? stat("Bracket", "bracket") : "") + stat("Avg. MV", "avgMv", function (v) { return v == null ? "–" : Number(v).toFixed(2); }) +
        stat("Value", "price", function (v) { return v ? KD.money(v) : "–"; });
      var row = function (s, i) {
        return '<li class="swap is-on" data-row="' + i + '" style="animation-delay:' + Math.min(i, 14) * 35 + 'ms"><label>' +
          '<input type="checkbox" checked data-swap="' + i + '" aria-label="Keep this swap">' +
          '<span class="swap__card swap__card--out">' + thumb(s.cut.imageUrl, s.cut.name) + "<span><s>" + (s.cut.qty > 1 ? s.cut.qty + "× " : "") + esc(s.cut.name) + "</s>" +
            (s.cut.reason ? "<small>" + esc(s.cut.reason) + "</small>" : "") + "</span></span>" +
          '<span class="swap__arrow">' + KD.icon("right") + "</span>" +
          '<span class="swap__card swap__card--in">' + thumb(s.add.imageUrl, s.add.name) + "<span><b>" + (s.add.qty > 1 ? s.add.qty + "× " : "") + esc(s.add.name) + "</b>" +
            (s.add.reason ? "<small>" + esc(s.add.reason) + "</small>" : "") +
            '<em class="mono">' + money(s.add.price) + (s.add.gameChanger ? " · Game Changer" : "") + "</em></span></span>" +
          "</label></li>";
      };
      var extras = (extraAdds.length ? '<div class="review__extra"><h4>Also added, to reach ' + D.targetSize(deck.format) + " cards</h4><ul>" +
          extraAdds.map(function (x) { return "<li>" + KD.icon("plus") + "<span>" + (x.qty > 1 ? x.qty + "× " : "") + esc(x.name) + (x.reason ? " <small>" + esc(x.reason) + "</small>" : "") + "</span></li>"; }).join("") + "</ul></div>" : "") +
        (extraCuts.length ? '<div class="review__extra"><h4>Also cut, to get down to ' + D.targetSize(deck.format) + " cards</h4><ul>" +
          extraCuts.map(function (x) { return "<li>" + KD.icon("minus") + "<span>" + (x.qty > 1 ? x.qty + "× " : "") + esc(x.name) + (x.reason ? " <small>" + esc(x.reason) + "</small>" : "") + "</span></li>"; }).join("") + "</ul></div>" : "");
      var free = !S.isPremium;
      var s = KD.sheet({
        title: "Review the changes", size: "lg",
        sub: esc(data.summary || ""),
        body: '<div class="review">' +
          '<div class="review__stats">' + stats + "</div>" +
          (swaps.length ? '<div class="review__bar"><label class="check"><input type="checkbox" checked data-all><span>Keep every swap</span></label><span class="mono" data-count></span></div>' +
            '<ol class="swaps">' + swaps.map(row).join("") + "</ol>" : "") +
          extras + notesHtml(data) + "</div>",
        foot: '<button class="btn btn--ghost" type="button" data-again>' + KD.icon("refresh") + "<span>Different picks" + (free ? " · uses a build" : "") + "</span></button>" +
          '<button class="btn btn--lure" type="button" data-apply>' + KD.icon("check") + "<span>Apply</span></button>"
      });
      var count = function () {
        var n = keep.filter(Boolean).length;
        var c = KD.$("[data-count]", s.el); if (c) c.textContent = n + " of " + swaps.length + " " + KD.plural(swaps.length, "swap");
        var extrasN = extraAdds.length + extraCuts.length ? 1 : 0;
        var btn = KD.$("[data-apply] span", s.el);
        btn.textContent = n || extrasN ? "Apply " + (n ? n + " " + KD.plural(n, "swap") : "changes") : "Nothing selected";
        KD.$("[data-apply]", s.el).disabled = !n && !extrasN;
        var all = KD.$("[data-all]", s.el); if (all) all.checked = n === swaps.length;
      };
      KD.$$("[data-swap]", s.el).forEach(function (cb) {
        cb.addEventListener("change", function () {
          var i = parseInt(cb.dataset.swap, 10);
          keep[i] = cb.checked;
          cb.closest(".swap").classList.toggle("is-on", cb.checked);
          count();
        });
      });
      var all = KD.$("[data-all]", s.el);
      if (all) all.addEventListener("change", function () {
        keep = keep.map(function () { return all.checked; });
        KD.$$("[data-swap]", s.el).forEach(function (cb) { cb.checked = all.checked; cb.closest(".swap").classList.toggle("is-on", all.checked); });
        count();
      });
      count();
      KD.$("[data-again]", s.el).addEventListener("click", function () {
        s.close();
        var avoid = (o.avoid || []).concat(swaps.map(function (x) { return x.add.name; }), extraAdds.map(function (x) { return x.name; }));
        KD.improve.run(Object.assign({}, o, { avoid: avoid.slice(-120) }));
      });
      KD.$("[data-apply]", s.el).addEventListener("click", async function () {
        var picks = { cuts: [], adds: [], cardData: data.cardData || null }; // cardData: the server's card data for every add and cut (2026-10-05)
        swaps.forEach(function (x, i) { if (!keep[i]) return; picks.cuts.push({ name: x.cut.name, qty: x.cut.qty }); picks.adds.push({ name: x.add.name, qty: x.add.qty }); });
        extraAdds.forEach(function (x) { picks.adds.push({ name: x.name, qty: x.qty }); });
        extraCuts.forEach(function (x) { picks.cuts.push({ name: x.name, qty: x.qty }); });
        s.close();
        await KD.improve.apply(picks);
      });
    },

    // ---------------------------------------------------------------- writing it
    apply: async function (picks, opt) {
      var host = B.host;
      if (!host || !host.deck()) return;
      var deck = host.deck();
      var n = Math.max(picks.cuts.length, picks.adds.length);
      KD.busy("Applying " + n + " " + KD.plural(n, "change") + "…");
      var res;
      try {
        await host.settle();
        res = await D.applyUpgrade(deck.id, host.cards(), picks);
      } catch (e) {
        console.error("apply upgrade", e);
        KD.idle();
        KD.toast("Some changes didn't save. The deck reloads so you can see where it stands.", "err");
        await host.reload();
        return;
      }
      KD.idle();
      await host.reload();
      host.edited();
      KD.ga("upgrade_applied", { swaps: n });
      if (opt && opt.undo) { KD.toast("Undone. The deck is back the way it was.", "ok"); return; }
      host.strip({
        kind: "info",
        title: "Applied " + n + " " + KD.plural(n, "change"),
        text: "Cut " + res.cut + ", added " + res.add + "." + (res.missing.length ? " Couldn't find " + res.missing.join(", ") + " in the deck anymore." : "") + " Not happy with it?",
        cta: '<button class="btn btn--ghost btn--sm" type="button" data-imp-undo>' + KD.icon("refresh") + "<span>Undo</span></button>",
        onCta: function () { KD.improve.apply({ cuts: picks.adds, adds: picks.cuts, cardData: picks.cardData }, { undo: true }); }
      });
    }
  };

  function notesHtml(data) {
    var notes = (data.notes || []).slice();
    var rej = data.rejected || [];
    var out = notes.length ? '<ul class="review__notes">' + notes.map(function (x) { return "<li>" + esc(x) + "</li>"; }).join("") + "</ul>" : "";
    if (rej.length) {
      out += '<details class="review__rej"><summary>' + rej.length + " " + KD.plural(rej.length, "suggestion") + " didn’t pass the checks" + KD.icon("down") + "</summary><ul>" +
        rej.slice(0, 30).map(function (r) { return "<li><b>" + esc(r.name) + "</b> · " + esc(r.why) + "</li>"; }).join("") + "</ul></details>";
    }
    return out;
  }
})();
